export const isValidEmail = (raw: string): boolean =>
  /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(raw.trim());
